import React from 'react';
import { Section, SectionHeading } from './Shared';
const points = ['Llegas sin saber qué serie prescribir', 'Improvisas, sin un protocolo que te respalde', 'Absorbes la carga energética del paciente', 'Armas cada sesión desde cero', 'Sin ficha clínica ni continuidad', 'Pacientes que no regresan'];
export const PainPoints = () => <Section className="max-w-4xl" data-id="element-189" data-mp="2bw7rqzjig41x">
    <SectionHeading eyebrow="El punto de partida" className="mb-7" data-id="element-190" data-mp="2bv6846ofi98l">
      ¿Cuántas sesiones más vas a improvisar sin un sistema clínico?
    </SectionHeading>

    <div className="relative max-w-2xl mx-auto mb-9 overflow-hidden rounded-3xl border border-brand-gold/50 bg-brand-greenSage/25 px-6 py-8 sm:px-10 text-center shadow-[0_18px_40px_-28px_rgba(46,40,32,0.6)]" data-id="element-191" data-mp="2204g932rqt2b">
      {/* Warm, living decor */}
      <span aria-hidden="true" className="pointer-events-none absolute -top-3 -left-2 text-5xl opacity-40 animate-float-soft select-none" data-id="element-192" data-mp="1t0ho77vxizlx">
        🪴
      </span>
      <span aria-hidden="true" className="pointer-events-none absolute -bottom-4 -right-1 text-5xl opacity-40 animate-float-soft select-none" style={{
      animationDelay: '1.4s'
    }} data-id="element-193" data-mp="3nc5xatfhc7ye">
        🌿
      </span>
      <span aria-hidden="true" className="pointer-events-none absolute top-4 right-6 text-2xl opacity-40 animate-float-soft select-none" style={{
      animationDelay: '2.2s'
    }} data-id="element-194" data-mp="1u1bwffxc3a11">
        🍵
      </span>
      <span aria-hidden="true" className="pointer-events-none absolute bottom-5 left-6 text-2xl opacity-35 animate-float-soft select-none" style={{
      animationDelay: '0.8s'
    }} data-id="element-195" data-mp="23thvf9m06rpq">
        🕯️
      </span>

      <div className="relative" data-id="element-196" data-mp="1b52koz9wmvk7">
        <span aria-hidden="true" className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-brand-paper border border-brand-gold/50 text-xl mb-4" data-id="element-197" data-mp="1p2r5k73z22p9">
          🤍
        </span>
        <p className="font-display text-lg sm:text-2xl leading-snug text-brand-purpleDark" data-id="element-198" data-mp="30h4n6u84tlwu">
          Saber Chi Kung no es lo mismo que tener un{' '}
          <span className="relative inline-block" data-id="element-199" data-mp="2vibc18gbi6zu">
            <span aria-hidden="true" className="absolute inset-x-[-3px] bottom-[0.08em] h-[0.32em] bg-brand-goldLight/70" data-id="element-200" data-mp="1t5y9amdnch3j" />
            <span className="relative font-semibold" data-id="element-201" data-mp="1y2x0ox5xe9y1">sistema clínico</span>
          </span>{' '}
          para aplicarlo con autoridad profesional.
        </p>
        <p className="mt-3 font-display italic text-base sm:text-lg text-brand-burgundy" data-id="element-202" data-mp="274o57yoqcaqb">
          Y esa diferencia se siente en cada consulta. 🌱
        </p>
      </div>
    </div>

    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2.5 max-w-3xl mx-auto mb-8" data-id="element-203" data-mp="1acucwt91nq58">
      {points.map(point => <li key={point} className="flex items-start gap-2.5" data-id="element-204" data-mp="1jflpwxhkityz">
          <span aria-hidden="true" className="mt-2 w-1.5 h-1.5 rotate-45 bg-brand-burgundy shrink-0" data-id="element-205" data-mp="1je0tf2bp10yh" />
          <span className="text-brand-text text-sm" data-id="element-206" data-mp="1o853vvk63r4b">{point}</span>
        </li>)}
    </ul>

    <p className="text-center text-xl md:text-2xl font-display font-semibold purple-gradient-text" data-id="element-207" data-mp="qqehn6sbaq0j">
      ¿Y si esta fuera la última sesión que trabajas así?
    </p>
  </Section>;